import React from 'react'

import useGeolocation from '../hooks/useGeolocation'
import { removeWhitespace } from '../logic/contentful'

export const phoneNumberCountries = ['FI', 'GB', 'US'] as const

export type PhoneNumberCountry = (typeof phoneNumberCountries)[number]

export type PhoneNumbersByCountry = Record<PhoneNumberCountry, string>

export const defaultPhoneNumbersByCountry: PhoneNumbersByCountry = {
  FI: '+358 50 336 6128',
  GB: '+44 787 187 7645',
  US: '+1 631 513 7813',
}

const isPhoneNumberCountry = (country: string): country is PhoneNumberCountry =>
  phoneNumberCountries.includes(country as PhoneNumberCountry)

// Show local phone number with following precedence rules:
// 1. country defined in props, if present
// 2. number for geolocated visitor IP country
// 3. fallbackPhoneNumber
const PhoneNumber = ({
  asLink = true,
  className,
  country,
  fallbackPhoneNumber = defaultPhoneNumbersByCountry.FI,
  phoneNumbersByCountry = defaultPhoneNumbersByCountry,
}: {
  asLink?: boolean
  className?: string
  country?: PhoneNumberCountry
  fallbackPhoneNumber?: string
  phoneNumbersByCountry?: Partial<PhoneNumbersByCountry>
}) => {
  const geolocatedCountry = useGeolocation()
  const countryToShow = country ?? geolocatedCountry
  const phoneNumber =
    (countryToShow &&
      isPhoneNumberCountry(countryToShow) &&
      phoneNumbersByCountry[countryToShow]) ||
    fallbackPhoneNumber

  return asLink ? (
    <a className={className} href={`tel:${removeWhitespace(phoneNumber)}`}>
      {phoneNumber}
    </a>
  ) : (
    <span className={className}>{phoneNumber}</span>
  )
}

export default PhoneNumber
